module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Banshee-S1.7bdcf6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Banshee-S1.jpg
// module id = tG50
// module chunks = 0